import dayjs from 'dayjs'

const transformDateParam = (params, name) => {
  const values = params.getAll(name)
  if (values.length === 2) {
    params.delete(name)
    params.set(`${name}_gteq`, dayjs(values[0]).startOf('day').toISOString())
    params.set(`${name}_lteq`, dayjs(values[1]).endOf('day').toISOString())
  }
}

const transformSearchParams = (search, dateFields) => {
  const params = new URLSearchParams(search)
  dateFields.forEach((field) => transformDateParam(params, field))
  return params.toString()
}

export default transformSearchParams
